import React from "react"
import { sortRowStyle } from "./styles"
import { SortOption } from "./hooks/useExplodedViewParts"
import { Icon } from "@ncs/web-legos/components"

type SortControlProps = {
	value: SortOption
	onChange: (value: SortOption) => void
}

export const SortControl: React.FC<SortControlProps> = ({ value, onChange }) => (
	<div css={sortRowStyle}>
		<div className="sort-select-wrapper">
			<select value={value} onChange={(e) => onChange(e.target.value as SortOption)}>
				<option value="part_index_asc">Bill of Materials (Low to High)</option>
				<option value="part_index_desc">Bill of Materials (High to Low)</option>
				<option value="part_name_asc">Name A-Z</option>
				<option value="part_name_desc">Name Z-A</option>
			</select>
			<Icon icon="sort" family="solid" />
		</div>
	</div>
)
